import * as React from 'react';

export default () => (
  <svg width="24" height="24" fill="none">
    <path stroke="#B5BFD2" strokeLinejoin="round" strokeWidth="2" d="M5 16V8l7-3 7 3v8l-7 3-7-3Z" />
    <path stroke="#B5BFD2" strokeWidth="2" d="M12 11v8m0-8L5 8m7 3 7-3" />
  </svg>
);
